module.exports = __webpack_public_path__ + "static/media/gochi_logo_print.a6109045.png";